(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blovo-single-image-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blovo-single-image-banner')) {
    customElements.define('blovo-single-image-banner', class extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('.blovo-single-image__link');
        if (!this.link) return;
        if (this.dataset.clickMode !== 'login_modal') return;
        this.link.addEventListener('click', (event) => this.handleLoginModeClick(event));
      }

      isSignedIn() {
        if (this.dataset.liquidSignedIn === 'true') return true;
        if (window.HeaderAccount && typeof window.HeaderAccount.isSignedIn === 'function') {
          try {
            return Boolean(window.HeaderAccount.isSignedIn());
          } catch (error) {
            return false;
          }
        }
        return false;
      }

      openLoginModalOrRedirect() {
        if (window.HeaderAccount && typeof window.HeaderAccount.openSheet === 'function') {
          window.HeaderAccount.openSheet();
          return;
        }
        const loginUrl = this.dataset.loginUrl || '/account/login';
        window.location.assign(loginUrl);
      }

      handleLoginModeClick(event) {
        if (this.isSignedIn()) return;
        event.preventDefault();
        this.openLoginModalOrRedirect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blovo-track-order"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blovo-order-tracker')) {
    customElements.define('blovo-order-tracker', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-track-form]');
        this.message = this.querySelector('[data-track-message]');
        this.result = this.querySelector('[data-track-result]');
        this.ordersNode = this.querySelector('[data-track-orders]');
        this.endpoint = this.dataset.endpoint;
        this.locale = document.documentElement.lang || navigator.language || 'en';
        this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
        this.form.addEventListener('submit', (event) => this.submit(event));
        const hasDeepLink = this.prefillFromQuery();
        if (this.dataset.loggedIn === 'true') {
          if (hasDeepLink) this.lookupFromForm();
          else this.loadOrders();
        } else if (hasDeepLink && this.canLookupAsGuest()) {
          this.lookupFromForm();
        }
      }

      prefillFromQuery() {
        const params = new URLSearchParams(window.location.search);
        const raw = params.get('order') || params.get('orderNumber') || '';
        if (!raw) return false;
        const orderInput = this.form.querySelector('[name="orderNumber"]');
        if (orderInput) orderInput.value = raw.replace(/^#/, '').trim();
        const email = params.get('email');
        const emailInput = this.form.querySelector('[name="email"]');
        if (email && emailInput) emailInput.value = email.trim();
        return Boolean(orderInput && orderInput.value);
      }

      canLookupAsGuest() {
        const emailInput = this.form.querySelector('[name="email"]');
        return Boolean(emailInput && emailInput.value);
      }

      text(key) {
        return this.dataset[key] || '';
      }

      icon(name) {
        const template = this.querySelector(`[data-icon="${name}"]`);
        return template ? template.content.firstElementChild.cloneNode(true) : document.createElement('span');
      }

      setMessage(value, error) {
        this.message.replaceChildren();
        if (!value) return;
        const iconName = error ? 'error' : value === this.text('loading') ? 'spinner' : 'info';
        const icon = this.icon(iconName);
        icon.setAttribute('aria-hidden', 'true');
        const text = document.createElement('span');
        text.textContent = value;
        this.message.append(icon, text);
        this.message.dataset.error = error ? 'true' : 'false';
      }

      proxyUrl(path) {
        let url = `${this.endpoint}${path}`;
        const customerId = (this.dataset.customerId || '').replace(/\D/g, '');
        if (customerId) {
          const separator = url.includes('?') ? '&' : '?';
          url += `${separator}logged_in_customer_id=${encodeURIComponent(customerId)}`;
        }
        return url;
      }

      async request(path, options) {
        const response = await fetch(this.proxyUrl(path), { credentials: 'same-origin', ...options });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.error?.message || this.text('genericError'));
        return payload.data;
      }

      async loadOrders() {
        this.setMessage(this.text('loading'), false);
        try {
          const data = await this.request('/orders');
          const orders = data.orders || [];
          this.setMessage(orders.length ? '' : this.text('noOrders'), false);
          if (!this.ordersNode || !orders.length) return;
          const list = document.createElement('div');
          list.className = 'blovo-track__order-list';
          orders.forEach((order) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'blovo-track__order-choice';
            const icon = this.icon('clipboard');
            icon.setAttribute('aria-hidden', 'true');
            const label = document.createElement('span');
            label.textContent = order.orderNumber;
            button.append(icon, label);
            button.addEventListener('click', async () => {
              const orderInput = this.form.querySelector('[name="orderNumber"]');
              if (orderInput) orderInput.value = order.orderNumber || '';
              await this.lookupFromForm();
            });
            list.append(button);
          });
          this.ordersNode.replaceChildren(list);
        } catch (error) {
          this.setMessage(error.message || this.text('genericError'), true);
        }
      }

      async submit(event) {
        event.preventDefault();
        await this.lookupFromForm();
      }

      async lookupFromForm() {
        const button = this.form.querySelector('button[type="submit"]');
        if (button) button.disabled = true;
        this.setMessage(this.text('loading'), false);
        this.result.replaceChildren();
        try {
          const values = Object.fromEntries(new FormData(this.form));
          const data = await this.request('/lookup', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(values),
          });
          this.setMessage('', false);
          this.renderOrder(data.order);
          this.updateShareableUrl(values, data.order);
          if (this.orderNeedsRefresh(data.order)) await this.refreshLookup(values);
        } catch (error) {
          this.setMessage(error.message || this.text('genericError'), true);
        } finally {
          if (button) button.disabled = false;
        }
      }

      updateShareableUrl(values, order) {
        const orderNumber = String(order?.orderNumber || values.orderNumber || '').replace(/^#/, '').trim();
        if (!orderNumber) return;
        const url = new URL(window.location.href);
        url.searchParams.delete('orderNumber');
        url.searchParams.set('order', orderNumber);
        const email = String(values.email || '').trim().toLowerCase();
        if (email) url.searchParams.set('email', email);
        else url.searchParams.delete('email');
        window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
      }


      orderNeedsRefresh(order) {
        const shipments = order?.shipments || [];
        return shipments.some((shipment) => shipment.registration_status !== 'registered' || !(shipment.events || []).length);
      }

      async refreshLookup(values) {
        this.setMessage(this.text('waitingRegistration') || this.text('syncing'), false);
        for (let attempt = 0; attempt < 3; attempt += 1) {
          await new Promise((resolve) => setTimeout(resolve, 2000));
          const data = await this.request('/lookup', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(values),
          });
          this.renderOrder(data.order);
          if (!this.orderNeedsRefresh(data.order)) {
            this.setMessage('', false);
            return;
          }
        }
        this.setMessage(this.text('syncing'), false);
      }

      statusLabel(status) {
        if (!status) return this.text('syncing');
        const key = status
          .replace(/([a-z])([A-Z])/g, '$1-$2')
          .replace(/_/g, '-')
          .toLowerCase();
        const dataKey = `status${key.split('-').map((part) => part.charAt(0).toUpperCase() + part.slice(1)).join('')}`;
        return this.text(dataKey) || status.replace(/_/g, ' ');
      }

      carrierLabel(value) {
        const normalized = (value || '').trim();
        if (!normalized || normalized === '其他' || normalized === '其它') return this.text('carrierOther');
        return normalized;
      }

      statusTone(status) {
        const value = (status || '').toLowerCase();
        if (!value) return 'pending';
        if (value.includes('deliver')) return 'delivered';
        if (value.includes('exception') || value.includes('failure') || value.includes('expired')) return 'issue';
        if (value.includes('transit') || value.includes('pickup') || value.includes('info')) return 'transit';
        return 'pending';
      }

      statusBadge(status) {
        const badge = document.createElement('span');
        const tone = this.statusTone(status);
        badge.className = `blovo-track__status-badge blovo-track__status-badge--${tone}`;
        const icon = this.icon(tone === 'delivered' ? 'success' : tone === 'issue' ? 'error' : 'truck');
        icon.setAttribute('aria-hidden', 'true');
        const label = document.createElement('span');
        label.textContent = this.statusLabel(status);
        badge.append(icon, label);
        return badge;
      }

      metaItem(iconName, label, value) {
        const item = document.createElement('div');
        item.className = 'blovo-track__meta-item';
        const iconWrap = document.createElement('span');
        iconWrap.className = 'blovo-track__meta-icon';
        const icon = this.icon(iconName);
        icon.setAttribute('aria-hidden', 'true');
        iconWrap.append(icon);
        const copy = document.createElement('div');
        const title = document.createElement('span');
        title.className = 'blovo-track__meta-label';
        title.textContent = label;
        const text = document.createElement('span');
        text.className = 'blovo-track__meta-value';
        text.textContent = value || '—';
        copy.append(title, text);
        item.append(iconWrap, copy);
        return item;
      }

      formatDateTime(value) {
        if (!value) return '';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return String(value);
        try {
          return new Intl.DateTimeFormat(this.locale, {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZone: this.timeZone,
            timeZoneName: 'short'
          }).format(date);
        } catch (_error) {
          return date.toLocaleString();
        }
      }

      renderOrder(order) {
        const article = document.createElement('article');
        article.className = 'blovo-track__order';
        const head = document.createElement('header');
        head.className = 'blovo-track__order-head';
        const title = document.createElement('h2');
        const titleIcon = this.icon('clipboard');
        titleIcon.setAttribute('aria-hidden', 'true');
        const titleText = document.createElement('span');
        titleText.textContent = order.orderNumber;
        title.append(titleIcon, titleText);
        head.append(title, this.statusBadge(order.fulfillmentStatus));
        article.append(head);
        const timezone = document.createElement('p');
        timezone.className = 'blovo-track__timezone';
        timezone.textContent = `${this.text('timezoneLabel')}: ${this.timeZone} (${this.text('timezoneDevice')})`;
        article.append(timezone);
        const shipments = order.shipments || [];
        if (!shipments.length) {
          const empty = document.createElement('p');
          empty.className = 'blovo-track__empty';
          const icon = this.icon('truck');
          icon.setAttribute('aria-hidden', 'true');
          const text = document.createElement('span');
          text.textContent = this.text('noTracking');
          empty.append(icon, text);
          article.append(empty);
        }
        shipments.forEach((shipment, index) => article.append(this.renderShipment(shipment, index)));
        this.result.replaceChildren(article);
        this.result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      renderShipment(shipment, index) {
        const section = document.createElement('section');
        section.className = 'blovo-track__shipment';
        const meta = document.createElement('div');
        meta.className = 'blovo-track__shipment-meta';
        const heading = document.createElement('h3');
        heading.className = 'blovo-track__shipment-title';
        const headingIcon = this.icon('truck');
        headingIcon.setAttribute('aria-hidden', 'true');
        const headingText = document.createElement('span');
        headingText.textContent = index === 0 ? 'Shipment' : `Shipment ${index + 1}`;
        heading.append(headingIcon, headingText);
        const grid = document.createElement('div');
        grid.className = 'blovo-track__meta-grid';
        grid.append(
          this.metaItem('truck', this.text('carrier'), this.carrierLabel(shipment.carrier_company)),
          this.metaItem('clipboard', this.text('trackingNumber'), shipment.tracking_number),
          this.metaItem('info', this.text('orderStatus'), this.statusLabel(shipment.package_status)),
          this.metaItem(
            'search',
            this.text('lastUpdated'),
            shipment.last_synced_at ? this.formatDateTime(shipment.last_synced_at) : this.text('syncing')
          )
        );
        meta.append(heading, grid);
        const events = document.createElement('ol');
        events.className = 'blovo-track__timeline';
        (shipment.events || []).forEach((event) => {
          const item = document.createElement('li');
          const time = document.createElement('time');
          time.className = 'blovo-track__event-time';
          if (event.event_time) time.dateTime = event.event_time;
          time.textContent = this.formatDateTime(event.event_time);
          const description = document.createElement('p');
          description.className = 'blovo-track__event-description';
          description.textContent = event.description || '';
          const location = document.createElement('div');
          location.className = 'blovo-track__event-location';
          location.textContent = event.location || '';
          item.append(time, description, location);
          events.append(item);
        });
        if (!events.children.length) {
          const item = document.createElement('li');
          item.className = 'blovo-track__timeline-sync';
          item.textContent = shipment.registration_status !== 'registered'
            ? (this.text('waitingRegistration') || this.text('syncing'))
            : this.text('syncing');
          events.append(item);
        }
        section.append(meta, events);
        return section;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bread-crumbs"] && !Shopify.designMode) return;
  try {
    
// Optional JavaScript for enhanced functionality

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
